<!--
    Generic modal for external redirection from AF
    Use the overlayStore to be displayed

    Params needed :
    - externalLink : used to display the link
    - eventName : used to send a reporting when clicking the link

    <ExternalRedirectionModal />
-->
<script setup lang="ts">
/* UTILS */
/* AF LIB */
import { ALButton, ALLink, useCssBreakpoints, ALModal } from '@af-lib/vue-ui';
import { computed } from 'vue';
/* COMPONENTS */
import Reporter from '@/api/clients/reporter/reporter';
/* STORE */
import { useOverlayStore } from '@/components/drawers/overlayStore';
/* CONSTANTS */
import { EXTERNAL_REDIRECTION_MODAL_NAME } from '@/enums/overlaysName';

/* STORE */
const overlayStore = useOverlayStore();

/* DISPLAY */
const { isMobile } = useCssBreakpoints();

/* COMPUTED */
const isModalOpen = computed({
  get: () => {
    return overlayStore.overlays[EXTERNAL_REDIRECTION_MODAL_NAME]?.open || false;
  },
  set: value => {
    overlayStore.resetParams(EXTERNAL_REDIRECTION_MODAL_NAME);
    const overlay = overlayStore.overlays[EXTERNAL_REDIRECTION_MODAL_NAME];
    if (overlay) {
      overlay.open = value;
    }
  }
});

const modalParams = computed(() => {
  return overlayStore.getOverlayParams(EXTERNAL_REDIRECTION_MODAL_NAME);
});

/**
 * Handle click on link to send reporting and close modal
 */
function onClickedLink() {
  if (modalParams.value.eventName) {
    setTimeout(() => {
      Reporter().reportData(modalParams.value.eventName, modalParams.value.eventParams || undefined);

      isModalOpen.value = false;
    }, 300);
  } else {
    isModalOpen.value = false;
  }
}
</script>

<template>
  <ALModal
    v-if="modalParams?.externalLink"
    v-model="isModalOpen"
    size="m"
    :title="$t('general.url.quit.title')"
    icon="warning"
  >
    <template #content>
      {{ $t('general.url.quit.body') }}
      <ALLink
        :label="modalParams.externalLink"
        :to="modalParams.externalLink"
        :class="isMobile ? 'mt-6' : 'mt-4'"
        size="m"
        @click="onClickedLink"
      />
    </template>
    <template #footer>
      <ALButton type="tertiary" :label="$t('general.close')" @click="isModalOpen = false" />
    </template>
  </ALModal>
</template>
